import React from 'react'
import { Link } from 'react-router-dom';

import { Img, Subgrid } from "./Gallery.element";

function Gallerimage() {
  return (
    <div style={{ padding: "60px" }}>
      <Subgrid>
  <Img src="\website data for 2025-26\12_photo gallary\photogallery1.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery2.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery3.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery4.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery5.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery6.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery7.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery8.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery9.JPG"></Img>
          <Img src="\website data for 2025-26\12_photo gallary\photogallery10.JPG"></Img>
        
      
      </Subgrid>
    </div>
  );
}

export default Gallerimage
